import React, { Component } from "react";
import { connect } from "react-redux";
import {
  View,
  StyleSheet,
  Alert,
  KeyboardAvoidingView,
  ScrollView,
} from "react-native";
import Switch from "../components/ToggleSwitch";
import Text from "../components_v2/TextFont";
import { CURTAIN_DIRECTION } from "../../assets/consts";

import * as Actions from "../actions/DeviceActions";
import * as DeviceTypes from "../components/devices/_deviceTypes";
import { translate } from "../locales/translate";
import ArButton from "../argon-ui/Button";
import Theme from "../argon-ui/Theme";
import Loading from "../components/Loading";
import InputBase from "../nativeBase-ui/InputBase";
import FontAwesomeIcon from "../components_v2/FontAwesomeIcon";
import { faEdit, faPlus } from "../../assets/consts/faCharCodes";
import { HStack } from "native-base";
import Select from "../nativeBase-ui/Select";
import MaterialDropdown from "../components_v2/MaterialDropdown";
import { TouchableWithoutFeedback } from "react-native-gesture-handler";

const DEFAULT_doorbellSMSReceiverMinRole = 100;

class DeviceFormScreen extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ...this.props.navigation.state.params,
      deviceName: "",
      deviceType: "",
      commandRelayId: null,
      commandRelayUId: null,
      statusRelayId: null,
      statusRelayUId: null,
      doorbellSMSBehavior: 0,
      doorbellSMSReceiverMinRole: DEFAULT_doorbellSMSReceiverMinRole,
      autoCloseSeconds: undefined,
      autoOffSeconds: undefined,
      ignoreCommandTimeSeconds: 0,
      isLoading: true,
      showAutoCloseSeconds: false,
      showIgnoreCommandTimeSeconds: false,
      showAutoOffSeconds: false,
      accessToken: "",
      validation_deviceName_hasError: false,
      showOnHomeScreen: "",
      isLite: undefined,
      direction: CURTAIN_DIRECTION.vertical,
    };

    this.typesDropdownItems = [
      DeviceTypes.POWER_SWITCH,
      DeviceTypes.LIGHT,
      DeviceTypes.LIGHT_DIMMER,
      DeviceTypes.AIR_CONDITIONER,
      DeviceTypes.CURTAIN,
      DeviceTypes.OUTLET,
      DeviceTypes.THERMO_METER,
      DeviceTypes.MOTION_SENSOR,
      DeviceTypes.LIGHT_METER,
      DeviceTypes.DOOR_SENSOR,
      DeviceTypes.DOORBELL,
      DeviceTypes.DOORLOCK,
      DeviceTypes.HIDDEN_SWITCH,
      DeviceTypes.LEAK_DETECTOR,
      DeviceTypes.SMOKE_DETECTOR,
      DeviceTypes.SENSOR_BINARY,
    ];

    // array with ke = deviceId and value = deviceName of airConditioners with no related status relay in order to use as command relay for current device.
    this.availableAirConditioners = [
      { value: 0, label: translate("device.none") },
    ];
    this.DoorbellSMSBehavior = ["Never", "WhenAway", "WhenAreaArmed", "Always"];
    this.DoorbellSMSReceiverRolesHelper = [
      {
        title: "AdminOnly",
        value: 1000,
      },
      {
        title: "AdminAndMember",
        value: 100,
      },
    ];
  }
  static navigationOptions = ({ screenProps: { translate } }) => ({
    headerTitle: translate("navigation.DeviceList"),
  });
  componentDidMount() {
    // get data from reducer using state.deviceId
    const accessToken = this.props.appReducer?.currentServer.accessToken;
    if (this.state.deviceUId || this.state.deviceId) {
      var model = {};
      for (var i in this.props.reducer.list) {
        // get model from reducer
        if (
          this.props.reducer.list[i].deviceId == this.state.deviceId ||
          (this.state.deviceUId &&
            this.props.reducer.list[i].deviceUId == this.state.deviceUId)
        ) {
          model = this.props.reducer.list[i];
          // console.log('model in device form did mount', model)
          var _allowedTypes = [];
          try {
            if (
              Array.isArray(model.allowedTypes) &&
              model.allowedTypes.length > 0
            ) {
              _allowedTypes = model.allowedTypes;
            } else if (
              model.device &&
              Array.isArray(model.device.allowedTypes) &&
              model.device.allowedTypes.length > 0
            ) {
              _allowedTypes = model.device.allowedTypes;
            }
          } catch (error) {}

          if (_allowedTypes.length > 0) {
            this.typesDropdownItems = _allowedTypes;
          }
          let showAutoCloseSeconds = false,
            showIgnoreCommandTimeSeconds = false,
            showAutoOffSeconds = false;
          if (model.deviceType == DeviceTypes.DOORLOCK) {
            showAutoCloseSeconds = true;
            showIgnoreCommandTimeSeconds = true;
          }

          let direction = this.state.direction;
          if (model.deviceType == DeviceTypes.CURTAIN) {
            direction = model.directionValue || CURTAIN_DIRECTION.vertical;
          }
          this.setState(
            {
              deviceName: model.deviceName,
              deviceType: model.deviceType,
              statusRelayId: model.statusRelayId,
              statusRelayUId: model.statusRelayUId,
              commandRelayId: model.commandRelayId,
              commandRelayUId: model.commandRelayUId,
              doorbellSMSBehavior: model.doorbellSMSBehavior,
              doorbellSMSReceiverMinRole: model.doorbellSMSReceiverMinRole,
              areaId: model?.areaId,
              areaUId: model?.areaUId,
              autoCloseSeconds: model.autoCloseSeconds,
              ignoreCommandTimeSeconds: model.ignoreCommandTimeSeconds || 0,
              autoOffSeconds: model.autoOffSeconds,
              showAutoCloseSeconds,
              showAutoOffSeconds,
              showIgnoreCommandTimeSeconds,
              showOnHomeScreen: model.showOnHomeScreen,
              isLite: model.isLite,
              direction,
            },
            () => {
              // if isLite is explicitly true, send getDetail request. otherwise ignore if is true or undefined(for backward compatibility)
              if (model.isLite === true) {
                this.props.getDetails(
                  model.deviceId,
                  model.deviceUId,
                  model.deviceType,
                  accessToken
                );
              }
            }
          );
          break;
        }
      }

      for (var i in this.props.reducer.list) {
        // get list of airConditioners for relate statusRelay and commandRelay
        if (!model.statusRelayId || !model.statusRelayUId) {
          let {
            deviceId,
            deviceUId,
            deviceName,
            deviceType,
            statusRelayId,
            statusRelayUId,
            commandRelayId,
            commandRelayUId,
          } = this.props.reducer.list[i];
          var _statusRelayId =
            !statusRelayId || statusRelayId == this.state.deviceId;
          var _statusRelayUId =
            !statusRelayUId || statusRelayUId == this.state.deviceUId;
          if (
            (deviceId != this.state.deviceId ||
              deviceUId != this.state.deviceUId) && // not current device
            deviceType == DeviceTypes.AIR_CONDITIONER && // device is AirConditioner
            (_statusRelayId || _statusRelayUId) && // has not related to any airConditioner or just related to this
            (!commandRelayId || !commandRelayUId) // has no commandRelay to itself
          ) {
            this.availableAirConditioners.push({
              value: deviceId || deviceUId,
              label: deviceName,
            });
          }
        }
      }
    }

    this.setState({
      accessToken,
      isLoading: false,
    });

    //  else {
    //   // else if is new device
    //   if (Number(this.state.includeTimeout)) {
    //     setTimeout(() => {
    //       this.setState({ includeTimeout: this.state.includeTimeout - 1 });
    //     }, 1000);
    //   }
    // }
  }

  onHealButtonPress = () => {
    Alert.alert("", translate("device.sendingHealCommand"), [
      {
        text: translate("app.confirm"),
        onPress: () => {
          this.setState({ isLoading: true });
          this.props.heal(
            this.state.deviceId || this.state.deviceUId,
            this.state.accessToken
          );
          setTimeout(() => {
            this.setState({ isLoading: false });
          }, 1000);
        },
      },
      { text: translate("app.cancel"), onPress: () => {} },
    ]);
  };

  goBack = () => {
    // this.props.navigation.navigate("DeviceList", { areaId: this.state.areaId });

    if (this.props.navigation) {
      // go back to prev screen
      this.props.navigation.goBack();

      // callback
      this.props.navigation.state.params.onGoBack &&
        this.props.navigation.state.params.onGoBack(this.state.deviceType);

      return false;
    }
  };

  // goToDeviceLog = () => {
  //   this.props.navigation.navigate("DeviceLogs", {
  //     deviceId: this.state.deviceId,
  //     deviceUId: this.state.deviceUId,
  //   });
  // };

  save = () => {
    var model = {
      // areaId: this.state.areaId, // areaId foreign key removed because data model changed into many-to-many relationship.
      deviceId: this.state.deviceId,
      deviceUId: this.state.deviceUId,
      deviceName: this.state.deviceName,
      deviceType: this.state.deviceType,
      showOnHomeScreen: this.state.showOnHomeScreen,
    };

    if (model.deviceType == DeviceTypes.AIR_CONDITIONER) {
      model.statusRelayId = this.state.statusRelayId;
      model.statusRelayUId = this.state.statusRelayUId;
      model.commandRelayId = this.state.commandRelayId;
      model.commandRelayUId = this.state.commandRelayUId;
    }

    if (model.deviceType == DeviceTypes.DOORBELL) {
      model.doorbellSMSBehavior = this.state.doorbellSMSBehavior;
      model.doorbellSMSReceiverMinRole =
        this.state.doorbellSMSReceiverMinRole ||
        DEFAULT_doorbellSMSReceiverMinRole;
    }

    if (model.deviceType == DeviceTypes.DOORLOCK) {
      model.ignoreCommandTimeSeconds = this.state.ignoreCommandTimeSeconds;
    }

    if (model.deviceType == DeviceTypes.CURTAIN) {
      model.direction = Number(this.state.direction);
    }

    if (this.state.autoCloseSeconds) {
      model.autoCloseSeconds = this.state.autoCloseSeconds;
    }

    if (this.state.autoOffSeconds) {
      model.autoOffSeconds = this.state.autoOffSeconds;
    }
    // validation
    let errors = [];
    if (!model.deviceName) {
      errors.push("device.deviceName");
      this.setState({ validation_deviceName_hasError: true });
    }
    if (!model.deviceType) {
      errors.push("device.deviceType");
    }
    if (
      (model.commandRelayId == 0 || model.commandRelayUId == "") &&
      model.deviceType == DeviceTypes.AIR_CONDITIONER
    ) {
      // set null instead of 0, to prevent invalid foreign key error on backend
      model.commandRelayId = null;
      model.commandRelayUId = null;
    }
    if (errors.length > 0) {
      let errorMessage = errors.map(
        (e) => `${translate(e)} ${translate("app.isRequired")}`
      );
      Alert.alert("", errorMessage.join("\r\n"));
      return;
    }
    // end of validation

    // if valid
    if (model.deviceId || model.deviceUId) {
      this.props.update(model, this.state.accessToken);
      this.goBack();
    } else {
      // insert model as new removed because devices will add automatically after including.
      // this.props.add(model , this.state.accessToken);
    }
  };

  handleDeviceTypeChange = (i, v) => {
    let dType = this.typesDropdownItems[i];
    let showAutoCloseSeconds = false,
      showIgnoreCommandTimeSeconds = false,
      showAutoOffSeconds = false;
    if (dType == DeviceTypes.DOORLOCK) {
      showAutoCloseSeconds = true;
      showIgnoreCommandTimeSeconds = true;
    } else {
      showAutoCloseSeconds = false;
      showIgnoreCommandTimeSeconds = false;
    }

    this.setState({
      deviceType: this.typesDropdownItems[i],
      showAutoCloseSeconds,
      showIgnoreCommandTimeSeconds,
      showAutoOffSeconds,
    });
  };

  handleCommandRelayChange = (v) => {
    var cR = {
      commandRelayId: 0,
      commandRelayUId: null,
    };
    if (typeof v == "string" && v.length > 31) {
      cR.commandRelayUId = v;
    } else {
      cR.commandRelayId = Number(v);
    }
    this.setState({
      commandRelayId: cR.commandRelayId,
      commandRelayUId: cR.commandRelayUId,
    });
  };

  handleDoorbellSMSBehaviorChange = (i, v) => {
    this.setState({ doorbellSMSBehavior: i });
  };

  handleDoorbellSMSReceiversChange = (i, v) => {
    this.setState({ doorbellSMSReceiverMinRole: i });
  };

  renderAirConditionerOptions = () => {
    if (this.state.statusRelayId || this.state.statusRelayUId) {
      return null; // do not show command relays if this device is already a command relay to another statusRelay
    }
    return (
      <View style={{ marginTop: 16 }}>
        <MaterialDropdown
          label={translate("device.commandRelay")}
          data={this.availableAirConditioners}
          value={
            this.state.commandRelayId || this.state.commandRelayUId
              ? this.availableAirConditioners.filter(
                  (v) =>
                    v.value == this.state.commandRelayId ||
                    v.value == this.state.commandRelayUId
                )[0].value
              : 0
          }
          onChangeText={(value, index, data) => {
            this.handleCommandRelayChange(value);
          }}
        />
      </View>
    );
  };

  renderDoorbellOptions = () => {
    return (
      <View>
        <View style={{ marginTop: 15 }}>
          <MaterialDropdown
            label={translate("device.doorbellSMSSendTitle")}
            data={this.DoorbellSMSBehavior.map((v) => {
              return { value: v, label: translate(`doorbellSMSBehavior.${v}`) };
            })}
            value={
              this.DoorbellSMSBehavior[this.state.doorbellSMSBehavior || 0]
            }
            onChangeText={(value, index, data) => {
              this.handleDoorbellSMSBehaviorChange(value);
            }}
          />
        </View>

        <View style={{ marginTop: 15 }}>
          <MaterialDropdown
            label={translate("device.doorbellSMSReceiverMinRoleTitle")}
            data={this.DoorbellSMSReceiverRolesHelper.map((v) => {
              return {
                value: v.value,
                label: translate(`doorbellSMSReceiverMinRole.${v.title}`),
              };
            })}
            value={
              this.state.doorbellSMSReceiverMinRole ||
              DEFAULT_doorbellSMSReceiverMinRole
            }
            onChangeText={(value, index, data) => {
              this.handleDoorbellSMSReceiversChange(value);
            }}
          />
        </View>
      </View>
    );
  };

  renderCurtainOptions = () => {
    return (
      <MaterialDropdown
        label={translate("device.curtainDirection")}
        data={[
          {
            value: CURTAIN_DIRECTION.vertical,
            label: translate("device.vertical"),
          },
          {
            value: CURTAIN_DIRECTION.horizontal,
            label: translate("device.horizontal"),
          },
        ]}
        value={this.state.direction || 0}
        onChangeText={(value, index, data) => {
          this.setState({ direction: value });
        }}
      />
    );
  };

  render() {
    // keep loading if isLite is explicitly true. ignore if is false or undefined(for backward compatibility)
    var _isLite = undefined;
    if (
      (this.state.deviceId > 0 || this.state.deviceUId) &&
      this.props.reducer
    ) {
      var dvc = this.props.reducer.list.filter(
        (d) =>
          (d.deviceId == this.state.deviceId ||
            d.deviceUId == this.state.deviceUId) &&
          d.deviceType == this.state.deviceType
      )[0];
      if (dvc) {
        _isLite = dvc.isLite;
      }
    }
    // console.log('_isLite', _isLite);
    if (this.state.isLoading || _isLite === true) {
      return <Loading message={translate("app.pleaseWaite")} />;
    } else {
      const screenTitle =
        this.state.deviceId || this.state.deviceUId
          ? this.state.deviceName || translate("app.noName")
          : translate("device.defineNewDevice");
      return (
        <KeyboardAvoidingView
          behavior="height"
          style={{ flex: 1 }}
          enabled={true}
          keyboardVerticalOffset={80}
        >
          <ScrollView
            style={style.container}
            contentContainerStyle={{ flex: 1 }}
          >
            <View style={{ flex: 1 }}>
              <View style={{ flexDirection: "row" }}>
                <Text style={{ color: Theme.COLORS.MUTED, flex: 1 }}>
                  {this.state.areaName} : {translate("device.devices")} :{" "}
                </Text>
                <TouchableWithoutFeedback
                  style={{
                    width: 40,
                    height: 36,
                    backgroundColor: Theme.COLORS.SUCCESS,
                    justifyContent: "center",
                    alignItems: "center",
                    borderRadius: 5,
                  }}
                  onPress={this.onHealButtonPress}
                >
                  <FontAwesomeIcon
                    icon={faPlus}
                    iconSize={18}
                    color={Theme.COLORS.WHITE}
                    onPress={this.onHealButtonPress}
                  />
                </TouchableWithoutFeedback>
              </View>
              <Text style={style.screenTitle}>{screenTitle}</Text>
              <InputBase
                inputStyle={{ height: 45 }}
                placeholder=""
                isInvalid={this.state.validation_deviceName_hasError}
                label={translate("device.deviceName")}
                onChangeText={(txt) =>
                  this.setState({
                    deviceName: txt,
                    validation_deviceName_hasError: txt.length == 0,
                  })
                }
                value={this.state.deviceName}
                icon={faEdit}
              />
              <View style={{ marginVertical: 10 }}>
                <MaterialDropdown
                  style={{ height: 45 }}
                  label={translate("device.deviceType")}
                  data={this.typesDropdownItems.map((v) => {
                    return { value: v, label: translate(`deviceGroup.${v}`) };
                  })}
                  value={this.state.deviceType || ""}
                  onChangeText={(value, index, data) => {
                    this.handleDeviceTypeChange(index);
                  }}
                />
              </View>
              {this.state.showAutoCloseSeconds && (
                <View style={{ marginTop: 30 }}>
                  <InputBase
                    keyboardType="numeric"
                    placeholder=""
                    label={translate("device.autoCloseSeconds")}
                    onChangeText={(txt) =>
                      this.setState({
                        autoCloseSeconds: Number(txt) || 0,
                      })
                    }
                    value={
                      this.state.autoCloseSeconds &&
                      this.state.autoCloseSeconds.toString()
                    }
                    icon={faEdit}
                  />
                </View>
              )}
              {this.state.showIgnoreCommandTimeSeconds && (
                <View style={{ marginVertical: 30 }}>
                  <InputBase
                    keyboardType="numeric"
                    placeholder=""
                    label={translate("device.ignoreCommandTimeSeconds")}
                    onChangeText={(txt) =>
                      this.setState({
                        ignoreCommandTimeSeconds: Number(txt) || 0,
                      })
                    }
                    value={
                      this.state.ignoreCommandTimeSeconds &&
                      this.state.ignoreCommandTimeSeconds.toString()
                    }
                    icon={faEdit}
                  />
                  <Text
                    style={{ fontSize: 12, textAlign: "right", marginTop: 10 }}
                  >
                    {this.state.ignoreCommandTimeSeconds
                      ? translate("device.ignoreCommandTimeSecondsHint", {
                          ignoreTime: this.state.ignoreCommandTimeSeconds,
                        })
                      : translate("device.ignoreCommandTimeSecondsHint_0")}
                  </Text>
                </View>
              )}
              {this.state.deviceType == DeviceTypes.AIR_CONDITIONER &&
                this.renderAirConditionerOptions()}

              {this.state.deviceType == DeviceTypes.DOORBELL &&
                this.renderDoorbellOptions()}

              {this.state.deviceType == DeviceTypes.CURTAIN &&
                this.renderCurtainOptions()}

              {/* show on home screen toggle */}
              <View
                style={{
                  flexDirection: "row",
                  marginTop: 20,
                  alignItems: "center",
                }}
              >
                <Switch
                  isOn={this.state.showOnHomeScreen}
                  onColor={Theme.COLORS.ACTIVE}
                  offColor={Theme.COLORS.MUTED}
                  size="small"
                  onToggle={() =>
                    this.setState({
                      showOnHomeScreen: !this.state.showOnHomeScreen,
                    })
                  }
                  animationSpeed={0}
                />
                <Text style={{ marginHorizontal: 5 }}>
                  {translate("device.showOnHomeScreen")}
                </Text>
              </View>
            </View>
            <HStack space={2} style={{ marginTop: 10 }}>
              <ArButton
                color="muted"
                onPress={() => this.goBack()}
                style={{ flex: 1 }}
              >
                {translate("app.goBack")}
              </ArButton>
              <ArButton
                color="primary"
                onPress={() => this.save()}
                style={{ flex: 1 }}
              >
                {translate("app.save")}
              </ArButton>
            </HStack>
            {/* <ArButton
              color="success"
              style={{ width: "100%" }}
              onPress={() => this.goToDeviceLog()}
            >
              {translate("area.logs")}
            </ArButton> */}
          </ScrollView>
        </KeyboardAvoidingView>
      );
    }
  }
}

const style = StyleSheet.create({
  container: {
    paddingTop: 20,
    paddingHorizontal: 10,
  },
  screenTitle: {
    textAlign: "center",
    fontWeight: "bold",
    fontSize: 26,
  },
  inputLabel: {
    fontWeight: "500",
    fontSize: 15.4,
    marginBottom: 4,
  },
  CheckBox: {
    alignSelf: "center",
    padding: 0,
    margin: 0,
    width: 16,
  },
});

const mapStateToProps = (state) => {
  return {
    reducer: state.DeviceReducer,
    appReducer: state.AppReducer,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    add: (device) => dispatch(Actions.Add(device)),
    update: (device, accessToken) =>
      dispatch(Actions.Update(device, accessToken)),
    getDetails: (deviceId, deviceUId, deviceType, accessToken) =>
      dispatch(
        Actions.GetDetails(deviceId, deviceUId, deviceType, accessToken)
      ),
    heal: (deviceId, accessToken) =>
      dispatch(Actions.Heal(deviceId, accessToken)),
    //remove: deviceId => dispatch(Actions.Remove(deviceId))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(DeviceFormScreen);
